<script lang="ts">
    import { spaLink } from "../../../../functionTools/navigation"
    import Icon from "../../../widgets/Icon.svelte"
    import { mdiArrowLeft } from "@mdi/js"

    let {
        mobileSubnavOpen = $bindable(false),
        path,
        title,
        closeMenu,
    }: {
        mobileSubnavOpen: boolean
        path: string
        title: string
        closeMenu: () => void
    } = $props()
</script>

<li class="parent-nav only-mobile">
    <button
        class="button"
        style="width: 100%; display: flex; justify-content: flex-start; align-items: center; gap: 0.5rem; font-size: var(bodyfontsize); padding-left: 0px;"
        onclick={() => (mobileSubnavOpen = false)}
    >
        <Icon path={mdiArrowLeft} size="1.2rem" />
        Zurück
    </button>
</li>
<li class="parent-nav only-mobile">
    <a
        href={path}
        use:spaLink
        onclick={(e) => {
            mobileSubnavOpen = false
            closeMenu()
            e.preventDefault()
        }}
        class="button"
        style="width: 100%; display: flex; justify-content: flex-start; font-size: var(bodyfontsize); font-weight: 600;"
    >
        Übersicht - {title}
    </a>
</li>
